<!-- 입대업체 그룹을 수정하거나 등록하는 버튼입니다. -->
<template>
  <v-btn elevation="0" color="#F9FCFF"
    @click="onClick"
  >
    <v-icon color="#0C98FE">
      mdi-plus
    </v-icon>
    <span>
      {{ '신규 그룹 추가' | translate }}
    </span>
    <!-- 신규 등록은 삭제여부를 비활성화 한다. -->
    <rental-company-group-popup
        :button-type="CODE.POPUP_TYPE.REGISTER"
        :show.sync="showPopup"
        :delete-yn-disabled="true"
        :rental-companies="rentalCompanies"
        @saved-complete="$emit('saved-complete')"
    />
  </v-btn>
</template>

<script>
import RentalCompanyGroupPopup from "@/views/rental-company/manager/group/RentalCompanyGroupPopup.vue";
export default {
  name: "RentalCompanyGroupAddButton",
  components: {RentalCompanyGroupPopup},

  props: {
    show:{
      type: Boolean,
      default: false,
    },
    rentalCompanies:{
      type: Array,
      default: undefined
    },
  },

  data() {
    return {
      showPopup:false,
    }
  },

  methods: {
    onClick() {
      this.showPopup = true
    }
  },
}
</script>

<style scoped>

</style>
